import { CommentChatMessageModel } from "./CommentChatMessageModel";

export class GroupCommentModel {
  Date: String;
  Comments: CommentChatMessageModel[];
  constructor(obj?: Partial<GroupCommentModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
